import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiHalfsmile3dSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_67)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1m-1.344 15.584c-.18-.191-.256-.393-.256-.584H8.6c0 .71.295 1.339.744 1.816.644.686 1.617 1.084 2.656 1.084s2.012-.398 2.656-1.084c.448-.477.744-1.106.744-1.816h-1.8c0 .19-.076.393-.256.584-.268.285-.747.516-1.344.516s-1.076-.23-1.344-.516M13.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75M8.5 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
                    fill={`url(#${_uniqueId}paint0_radial_8745_67)`}
                    suppressHydrationWarning
                />
                <path
                    d="M10.4 16c0 .19.076.393.256.584.268.285.747.516 1.344.516s1.076-.23 1.344-.516c.18-.191.256-.393.256-.584h1.8c0 .71-.296 1.339-.744 1.816-.644.686-1.617 1.084-2.656 1.084s-2.012-.398-2.656-1.084C8.895 17.339 8.6 16.71 8.6 16z"
                    fill={`url(#${_uniqueId}paint1_radial_8745_67)`}
                    suppressHydrationWarning
                />
                <path
                    d="M6.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75"
                    fill={`url(#${_uniqueId}paint2_radial_8745_67)`}
                    suppressHydrationWarning
                />
                <path
                    d="M15.5 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
                    fill={`url(#${_uniqueId}paint3_radial_8745_67)`}
                    suppressHydrationWarning
                />
            </g>
            <path
                d="M10.4 16c0 .19.076.393.256.584.268.285.747.516 1.344.516s1.076-.23 1.344-.516c.18-.191.256-.393.256-.584h1.8c0 .71-.296 1.339-.744 1.816-.644.686-1.617 1.084-2.656 1.084s-2.012-.398-2.656-1.084C8.895 17.339 8.6 16.71 8.6 16z"
                fill="#79610C"
            />
            <path
                d="M6.75 9.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75"
                fill="#79610C"
            />
            <path
                d="M15.5 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
                fill="#79610C"
            />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_67`}
                    x={1}
                    y={-2.75}
                    width={25.75}
                    height={25.75}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={3.75} dy={-3.75} />
                    <feGaussianBlur stdDeviation={3.75} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_67" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_67`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_67`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_67`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_67`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(16.7094 5.125) rotate(127.875) scale(19.5968)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiHalfsmile3dSize24Glyph.displayName = 'EmojiHalfsmile3dSize24Glyph';
